/* eslint-disable func-names */
import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import Logger from '../../../shared/logger';
import template from './template.html';
import './style.scss';
import defaultAssociatedEmployersSettings from '../associatedEmployersSettings/defaultAssociatedEmployersSettings';
import { EmployerRepAuthTypes } from '../../../constants/employerRepAuthTypes';
import UtilsService from '../../../services/utilsService';
import {URL_REGEX} from "../../../constants/regex";

const MAX_SUGGEST_COMPANIES = 10;
const MIN_COMPANY_NAME_LENGTH_TO_SEARCH = 3;

const InterestedCandidateContacts = {
    PHONE: 'phone',
    EMAIL: 'email',
};

const AutoCampaignTypes = {
    DIVERSITY: 'diversity',
    REGULAR: 'regular',
    HYBRID: 'hybrid',
};

const DiversityTargets = {
    FEMALE: 'female',
    BLACK: 'black',
    HISPANIC: 'hispanic',
    ASIAN: 'asian',
    VETERAN: 'veteran',
};

export class CreateNewEmployer {
    /* @ngInject */
    constructor(
        $state,
        $scope,
        CompanyService,
        EmployerService,
        EmployerRepService,
        IdentifiersService,
        $stateParams,
        $cookies,
        $timeout,
        LocationService,
        $q,
        $translate,
        $window,
        RouteService,
        permissions,
        NotificationService,
        OfficeService,
        staticDataService,
        RecruiterService,
        WebAppRouteService,
        ModalDialogService,
    ) {
        this.companyService = CompanyService;
        this.locationService = LocationService;
        this.staticDataService = staticDataService;
        this.identifiersService = IdentifiersService;
        this.WebAppRouteService = WebAppRouteService;
        this.notificationService = NotificationService;
        this.ModalDialogService = ModalDialogService;
        this.$scope = $scope;
        const createEmpCtrl = this;
        createEmpCtrl.urlRegexPattern = URL_REGEX;
        createEmpCtrl.isGenerateSpecialtiesButtonEnabled = createEmpCtrl.getIsGenerateSpecialtiesButtonEnabled();
        createEmpCtrl.isCompaniesLoading = false;
        createEmpCtrl.isSpecialtiesLoading = false;
        createEmpCtrl.isTalentExpertUser = permissions.isTalentExpertUser();
        createEmpCtrl.isTalenyaUser = permissions.isTalenyaUser();
        createEmpCtrl.isSuperUser = permissions.isTalentExpertUser() || permissions.isTalenyaUser();
        createEmpCtrl.countriesList = [];

        createEmpCtrl.AutoCampaignTypes = AutoCampaignTypes;
        createEmpCtrl.DiversityTargets = DiversityTargets;
        createEmpCtrl.EmployerRepAuthTypes = EmployerRepAuthTypes;

        createEmpCtrl.isRecalibrationFlowEnabled = RouteService.getSystemPreference('isRecalibrationFlowEnabled');

        createEmpCtrl.diversityOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_OFF_OPTION', value: false },
        ];
        createEmpCtrl.diversityReportOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_REPORT_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_REPORT_OFF_OPTION', value: false },
        ];
        createEmpCtrl.diversityTagOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_TAG_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_TAG_OFF_OPTION', value: false },
        ];
        createEmpCtrl.campaignEngagementOptions = [
            { label: 'EMPLOYER_CAMPAIGN_ENGAGEMENT_ON_OPTION', value: true },
            { label: 'EMPLOYER_CAMPAIGN_ENGAGEMENT_OFF_OPTION', value: false },
        ];
        createEmpCtrl.linkedinConnectionsOptions = [
            { label: 'EMPLOYER_LINKEDIN_CONNECTIONS_ON_OPTION', value: true },
            { label: 'EMPLOYER_LINKEDIN_CONNECTIONS_OFF_OPTION', value: false },
        ];

        createEmpCtrl.linkedinInMailConnectionsOptions = [
            { label: 'EMPLOYER_LINKEDIN_IN_MAIL_CONNECTIONS_ON_OPTION', value: true },
            { label: 'EMPLOYER_LINKEDIN_IN_MAIL_CONNECTIONS_OFF_OPTION', value: false },
        ];

        createEmpCtrl.campaignsAnalysisPageOptions = [
            { label: 'EMPLOYER_CAMPAIGNS_ANALYSIS_PAGE_ON_OPTION', value: true },
            { label: 'EMPLOYER_CAMPAIGNS_ANALYSIS_PAGE_OFF_OPTION', value: false },
        ];

        createEmpCtrl.contactForEmployerOptions = [
            { label: 'EMPLOYER_CONTACT_ON_OPTION', value: true },
            { label: 'EMPLOYER_CONTACT_OFF_OPTION', value: false },
        ];
        createEmpCtrl.profileHiddenDetailsPreviewOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.showManageJobOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.isProfileFeedbackModeEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.isNewLandingPageEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.showWizardSamplesPageOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.isEmployerPostScrapingEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.jobWizardFastRatingOptions = [
            { label: 'WIZARD_FAST_RATING_OPTION_ON', value: true },
            { label: 'WIZARD_FAST_RATING_OPTION_OFF', value: false },
        ];

        createEmpCtrl.onlyFastRatingAllowedOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.skipCalibrationForSimilarJobsAllowedOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.isRecalibrationEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.isManualQualifyEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.isManualQualifyManualFlowEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.isManualQualifyManualFlowEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];
        
        createEmpCtrl.isManualQualifyLowTalentPoolEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.isManualQualifyManualMessagingEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.switchOnAutoCampaignOnCompleteCalibrationOptionsOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.autoCampaignTypeOptions = [
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_RADIO_BUTTON_REGULAR_CAMPAIGN_LABEL', value: AutoCampaignTypes.DIVERSITY },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_RADIO_BUTTON_REGULAR_HYBRID_LABEL', value: AutoCampaignTypes.HYBRID },
        ];

        createEmpCtrl.autoCampaignDiversityOptions = [
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_WOMEN', value: 'female' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_BLACK', value: 'black' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_HISPANIC', value: 'hispanic' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_ASIAN', value: 'asian' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_VETERANS', value: 'veteran' },
        ];

        createEmpCtrl.GDPROptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.yesNoOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        createEmpCtrl.onOffOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        createEmpCtrl.companiesExcludeOptions = [
            { label: 'Current', value: '-2' },
            { label: 'Current or Past', value: '-1' },
        ];

        createEmpCtrl.atsAutoUploadFilterEnabledOptions = [
            { label: 'Enabled', value: true },
            { label: 'Disabled', value: false },
        ];

        createEmpCtrl.atsJobIdOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_JOB_ID_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_JOB_ID_OFF_OPTION', value: false },
        ];

        createEmpCtrl.atsJobUrlOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_JOB_URL_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_JOB_URL_OFF_OPTION', value: false },
        ];

        createEmpCtrl.atsRecruiterOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_RECRUITER_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_RECRUITER_OFF_OPTION', value: false },
        ];

        createEmpCtrl.interestedCandidateRequiredContactOptions = [
            { label: 'Mandatory', value: true },
            { label: 'Optional', value: false },
        ];

        createEmpCtrl.bulkActionsContactByLinkedInEnabledOptions = [
            { label: 'EMPLOYER_PROFILE_BULK_ACTIONS_CONTACT_BY_LINKEDIN_ENABLED_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_BULK_ACTIONS_CONTACT_BY_LINKEDIN_ENABLED_OFF_OPTION', value: false },
        ];

        createEmpCtrl.programmaticCampaignOptions = [
            { label: 'Off', value: '' },
            { label: 'All Jobs', value: 'auto' },
            { label: 'Per Job', value: 'manual' },
        ];

        createEmpCtrl.tftMainLogoUrl = RouteService.getThemeSettings('tftMainLogoUrl') || '';

        createEmpCtrl.init = function () {
            UtilsService.cookiesOverride($cookies);
            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
            const userData = UtilsService.parseJSON($cookies.get('userData'));

            window.scrollTo({ top: 0, behavior: 'smooth' });
            createEmpCtrl.outSideUser = false;

            createEmpCtrl.initialData = {
                name: '',
                contact: {
                    phone: [],
                    email: [],
                    webAddress: [],
                    linkedInURL: '',
                    facebookURL: '',
                    twitterURL: '',
                },
                office: 'OFFICE_TRIAL',
                description: '',
                internalNotes: '',
                companies: {
                    field: 'companies',
                    type: 'dynamic',
                    subCriteria: null,
                    multiple: true,
                    selected: [],
                },
                specialties: {
                    field: 'specialties',
                    type: 'dynamic',
                    dropDownText: 'GENERATE_SPECIALTIES_TOOLTIP',
                    subCriteria: null,
                    multiple: true,
                    selected: [],
                },
                locations: [],
                logoURL: '',
                employerReps: [],
                isDiversityEnabled: true,
                settings: {
                    isDiversityReportEnabled: true,
                    isDiversityTagEnabled: false,
                    isContactForEmployerEnabled: true,
                    areLinkedinConnectionsEnabled: true,
                    areLinkedinInMailConnectionsEnabled: false,
                    isCampaignsAnalysisPageEnabled: true,
                    isPositionRecommendationsEnabled: true,
                    isEngagementEnabled: true,
                    sendersAuthenticateDomain: '',
                    isProfileHiddenDetailsPreviewEnabled: false,
                    defaultCompaniesExcludeOption: '-1',
                    isGDPR: false,
                    showAtsJobId: false,
                    showAtsJobUrl: false,
                    atsJobUrlTemplate: '',
                    atsCandidateUrlTemplate: '',
                    websiteJobUrlTemplate: '',
                    atsType: '',
                    atsTalenyaSourceId: '',
                    atsProgrammaticSourceId: '',
                    programmaticCampaignType: '',
                    showAtsRecruiter: false,
                    interestedCandidateRequiredContacts: [],
                    showManageJob: false,
                    isProfileFeedbackModeEnabled: true,
                    showWizardSamplesPage: false,
                    isBulkActionsContactByLinkedInEnabled: true,
                    allowTalenyaUserAsAnEmailSender: true,
                    shortUrl: '',
                    isJobWizardFastRatingEnabled: true,
                    autoCampaignOptions: {
                        autoCampaignType: AutoCampaignTypes.REGULAR,
                        selectedDiversityTarget: [],
                    },
                    switchOnAutoCampaignOnCompleteCalibration: false,
                    allowTalenyaDefaultEmployerRepForAtsPositions: true,
                    atsAutoUploadFilter: {
                        field: 'atsAutoUploadFilter',
                        type: 'dynamic',
                        subCriteria: null,
                        multiple: true,
                        selected: [],
                    },
                    isDepartmentsEnabled: false,
                    isNewLandingPageEnabled: true,
                    isEmployerPostScrapingEnabled: false,
                    isResellerPartner: false,
                    isDemoEmployer: false,
                    isOnlyFastRatingAllowed: false,
                    isSkipCalibrationForSimilarJobsAllowed: false,
                    isManualQualifyEnabled: false,
                    isManualQualifyManualFlowEnabled: false,
                    isManualQualifyLowTalentPoolEnabled: false,
                    isManualQualifyManualMessagingEnabled: false,
                    isEmailEnabled: true,
                    systemNotificationsSenderEmail: '',
                    isAutoInviteToRateEnabled: false,
                    isUploadMonitorEnabled: true,
                    isCompanyOverviewVisible: true,
                    isAutoContactAutoSelectEnabled: false,
                    isAutoQualifyEnabled: false,
                    isAtsJobsAutoPushStatusEnabled: false,
                    isAIJobDescriptionGenerationEnabled: false,
                    videoUrl: '',
                    isCandidateFastApplyEnabled: false,
                    isFastCalibrationEnabled: false,
                    atsCompanyWebsite: '',
                    atsCompanyLinkedinId: '',
                },
                doNotReplyEmail: '',
                senderEmailDomainOverride: '',
                resellerEmployerName: '',
                authData: {
                    authType: 'pap',
                    extraAuthTypes: [],
                },
            };

            createEmpCtrl.employerData = createEmpCtrl.initialData;

            createEmpCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length == 0 && !$noteEditor.is(event.target)) {
                                // click outside of summernote
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };

            if (!userData?.roles || userData?.roles?.length === 0) {
                if (userPrefs) {
                    if (userPrefs.entityId) {
                        $state.go('register');
                        return;
                    }
                }
                createEmpCtrl.outSideUser = true;
            } else if (permissions.isTalentExpertUser()
                || userData?.roles?.indexOf('AM') >= 0) {
                createEmpCtrl.talenyaUserAM = true;
            }

            const isNewEmployer = !$stateParams.empId;

            if (isNewEmployer) {
                if (createEmpCtrl.outSideUser === true) {
                    createEmpCtrl.employerData.contact.email.push({
                        type: 'Work',
                        value: userData?.email,
                    });
                }
                createEmpCtrl.isNew = true;

                if ($stateParams.isResellerAssociatedEmployer) {
                    createEmpCtrl.isResellerAssociatedEmployer = true;

                    const resellerEmployerId = $stateParams.employerId;

                    EmployerService.getEmployer(resellerEmployerId).then((response) => {
                        const resellerEmployer = response?.result;
                        // eslint-disable-next-line max-len
                        const advancedSettings = resellerEmployer.defaultAssociatedEmployersSettings?.settings || defaultAssociatedEmployersSettings.settings;
                        // eslint-disable-next-line max-len
                        const defaultAccountManagerRecruiter = resellerEmployer.defaultAssociatedEmployersSettings?.defaultAccountManagerRecruiter || resellerEmployer.defaultAssociatedRecruiter;
                        // eslint-disable-next-line max-len
                        const defaultAssociatedRecruiter = resellerEmployer.defaultAssociatedEmployersSettings?.defaultAssociatedRecruiter || resellerEmployer.defaultAssociatedRecruiter;
                        const office = resellerEmployer.defaultAssociatedEmployersSettings?.office || defaultAssociatedEmployersSettings.office;
                        // eslint-disable-next-line max-len
                        const doNotReplyEmail = resellerEmployer.defaultAssociatedEmployersSettings?.doNotReplyEmail || defaultAssociatedEmployersSettings.doNotReplyEmail;
                        // eslint-disable-next-line max-len
                        const isDiversityEnabled = resellerEmployer.defaultAssociatedEmployersSettings ? resellerEmployer.defaultAssociatedEmployersSettings.isDiversityEnabled : defaultAssociatedEmployersSettings.isDiversityEnabled;

                        const settings = {
                            ...resellerEmployer.settings,
                            isResellerPartner: false,
                            ...advancedSettings,
                            isDemoEmployer: resellerEmployer.settings.isDemoEmployer,
                            isEmailEnabled: !resellerEmployer.settings.isDemoEmployer,
                            isCandidatesAtsIntegrationOn: _.get(resellerEmployer, 'settings.isCandidatesAtsIntegrationOn', false),
                            isLineBreakTagInJobDescriptionEnabled: true,
                        };

                        const employerData = {
                            name: '',
                            resellerEmployerId,
                            resellerCompanyId: '',
                            defaultAccountManagerRecruiter,
                            defaultAssociatedRecruiter,
                            isDiversityEnabled,
                            office,
                            doNotReplyEmail,
                            settings,
                            resellerEmployerName: resellerEmployer.name,
                        };

                        createEmpCtrl.employerData = employerData;
                        createEmpCtrl.resellerEmployer = resellerEmployer;
                    });
                }
            } else {
                createEmpCtrl.isNew = false;
                EmployerService.getEmployer($stateParams.empId)
                    .then((response) => {
                        createEmpCtrl.employerData = response.result;
                        createEmpCtrl.employerData.isDiversityEnabled = _.get(createEmpCtrl, 'employerData.isDiversityEnabled', true);
                        createEmpCtrl.employerData.settings.isDiversityReportEnabled = _.get(createEmpCtrl, 'employerData.settings.isDiversityReportEnabled', true);
                        createEmpCtrl.employerData.settings.isDiversityTagEnabled = _.get(createEmpCtrl, 'employerData.settings.isDiversityTagEnabled', false);
                        createEmpCtrl.employerData.settings.isContactForEmployerEnabled = _.get(createEmpCtrl, 'employerData.settings.isContactForEmployerEnabled', false);
                        createEmpCtrl.employerData.settings.isEngagementEnabled = _.get(createEmpCtrl, 'employerData.settings.isEngagementEnabled', false);
                        createEmpCtrl.employerData.settings.areLinkedinConnectionsEnabled = _.get(createEmpCtrl, 'employerData.settings.areLinkedinConnectionsEnabled', true);
                        createEmpCtrl.employerData.settings.areLinkedinInMailConnectionsEnabled = _.get(createEmpCtrl, 'employerData.settings.areLinkedinInMailConnectionsEnabled', false);
                        createEmpCtrl.employerData.settings.isCampaignsAnalysisPageEnabled = _.get(createEmpCtrl, 'employerData.settings.isCampaignsAnalysisPageEnabled', true);
                        createEmpCtrl.employerData.settings.sendersAuthenticateDomain = _.get(createEmpCtrl, 'employerData.settings.sendersAuthenticateDomain', '');
                        createEmpCtrl.employerData.settings.isPositionRecommendationsEnabled = _.get(createEmpCtrl, 'employerData.settings.isPositionRecommendationsEnabled', true);
                        createEmpCtrl.employerData.settings.isGDPR = _.get(createEmpCtrl, 'employerData.settings.isGDPR', false);
                        createEmpCtrl.employerData.settings.showManageJob = _.get(createEmpCtrl, 'employerData.settings.showManageJob', false);
                        createEmpCtrl.employerData.settings.isProfileFeedbackModeEnabled = _.get(createEmpCtrl, 'employerData.settings.isProfileFeedbackModeEnabled', false);
                        createEmpCtrl.employerData.settings.showWizardSamplesPage = _.get(createEmpCtrl, 'employerData.settings.showWizardSamplesPage', false);
                        createEmpCtrl.employerData.settings.showAtsJobId = _.get(createEmpCtrl, 'employerData.settings.showAtsJobId', false);
                        createEmpCtrl.employerData.settings.showAtsJobUrl = _.get(createEmpCtrl, 'employerData.settings.showAtsJobUrl', false);
                        createEmpCtrl.employerData.settings.showAtsRecruiter = _.get(createEmpCtrl, 'employerData.settings.showAtsRecruiter', false);
                        createEmpCtrl.employerData.settings.interestedCandidateRequiredContacts = _.get(createEmpCtrl, 'employerData.settings.interestedCandidateRequiredContacts', []);
                        createEmpCtrl.employerData.settings.shortUrl = _.get(createEmpCtrl, 'employerData.settings.shortUrl', '');
                        createEmpCtrl.employerData.settings.isBulkActionsContactByLinkedInEnabled = _.get(createEmpCtrl, 'employerData.settings.isBulkActionsContactByLinkedInEnabled', true);
                        createEmpCtrl.employerData.settings.isJobWizardFastRatingEnabled = _.get(createEmpCtrl, 'employerData.settings.isJobWizardFastRatingEnabled', false);
                        createEmpCtrl.employerData.settings.switchOnAutoCampaignOnCompleteCalibration = _.get(createEmpCtrl, 'employerData.settings.switchOnAutoCampaignOnCompleteCalibration', false);
                        createEmpCtrl.employerData.settings.allowTalenyaDefaultEmployerRepForAtsPositions = _.get(createEmpCtrl, 'employerData.settings.allowTalenyaDefaultEmployerRepForAtsPositions', true);
                        createEmpCtrl.employerData.settings.autoCampaignOptions = _.get(createEmpCtrl, 'employerData.settings.autoCampaignOptions', {});
                        createEmpCtrl.employerData.settings.autoCampaignOptions.autoCampaignType = _.get(createEmpCtrl, 'employerData.settings.autoCampaignOptions.autoCampaignType', 'regular');
                        createEmpCtrl.employerData.settings.autoCampaignOptions.selectedDiversityTarget = _.get(createEmpCtrl, 'employerData.settings.autoCampaignOptions.selectedDiversityTarget', []);
                        createEmpCtrl.employerData.settings.isNewLandingPageEnabled = _.get(createEmpCtrl, 'employerData.settings.isNewLandingPageEnabled', false);
                        createEmpCtrl.employerData.settings.isEmployerPostScrapingEnabled = _.get(createEmpCtrl, 'employerData.settings.isEmployerPostScrapingEnabled', false);
                        createEmpCtrl.employerData.settings.isResellerPartner = _.get(createEmpCtrl, 'employerData.settings.isResellerPartner', false);
                        createEmpCtrl.employerData.settings.isDemoEmployer = _.get(createEmpCtrl, 'employerData.settings.isDemoEmployer', false);
                        createEmpCtrl.employerData.resellerEmployerId = _.get(createEmpCtrl, 'employerData.resellerEmployerId', false);
                        createEmpCtrl.employerData.settings.isOnlyFastRatingAllowed = _.get(createEmpCtrl, 'employerData.settings.isOnlyFastRatingAllowed', false);
                        createEmpCtrl.employerData.settings.isSkipCalibrationForSimilarJobsAllowed = _.get(createEmpCtrl, 'employerData.settings.isSkipCalibrationForSimilarJobsAllowed', false);
                        createEmpCtrl.employerData.settings.isManualQualifyEnabled = _.get(createEmpCtrl, 'employerData.settings.isManualQualifyEnabled', false);
                        createEmpCtrl.employerData.settings.isManualQualifyManualFlowEnabled = _.get(createEmpCtrl, 'employerData.settings.isManualQualifyManualFlowEnabled', false);
                        createEmpCtrl.employerData.settings.isManualQualifyLowTalentPoolEnabled = _.get(createEmpCtrl, 'employerData.settings.isManualQualifyLowTalentPoolEnabled', false);
                        createEmpCtrl.employerData.settings.isManualQualifyManualMessagingEnabled = _.get(createEmpCtrl, 'employerData.settings.isManualQualifyManualMessagingEnabled', false);
                        createEmpCtrl.employerData.settings.isEmailEnabled = _.get(createEmpCtrl, 'employerData.settings.isEmailEnabled', true);
                        createEmpCtrl.employerData.settings.systemNotificationsSenderEmail = _.get(createEmpCtrl, 'employerData.settings.systemNotificationsSenderEmail', '');
                        createEmpCtrl.employerData.settings.isAutoInviteToRateEnabled = _.get(createEmpCtrl, 'employerData.settings.isAutoInviteToRateEnabled', false);
                        _.set(createEmpCtrl, 'employerData.settings.authData.authType', _.get(createEmpCtrl, 'employerData.settings.authData.authType', ''));
                        _.set(createEmpCtrl, 'employerData.settings.authData.extraAuthTypes', _.get(createEmpCtrl, 'employerData.settings.authData.extraAuthTypes', []));
                        createEmpCtrl.employerData.settings.isUploadMonitorEnabled = _.get(createEmpCtrl, 'employerData.settings.isUploadMonitorEnabled', false);
                        createEmpCtrl.employerData.settings.isCompanyOverviewVisible = _.get(createEmpCtrl, 'employerData.settings.isCompanyOverviewVisible', false);
                        createEmpCtrl.employerData.settings.atsProgrammaticSourceId = _.get(createEmpCtrl, 'employerData.settings.atsProgrammaticSourceId', '');
                        createEmpCtrl.employerData.settings.programmaticCampaignType = _.get(createEmpCtrl, 'employerData.settings.programmaticCampaignType', '');
                        createEmpCtrl.employerData.settings.atsTalenyaSourceId = _.get(createEmpCtrl, 'employerData.settings.atsTalenyaSourceId', '');
                        createEmpCtrl.employerData.settings.isAutoContactAutoSelectEnabled = _.get(createEmpCtrl, 'employerData.settings.isAutoContactAutoSelectEnabled', false);
                        createEmpCtrl.employerData.settings.isAutoQualifyEnabled = _.get(createEmpCtrl, 'employerData.settings.isAutoQualifyEnabled', false);
                        createEmpCtrl.employerData.settings.isAtsJobsAutoPushStatusEnabled = _.get(createEmpCtrl, 'employerData.settings.isAtsJobsAutoPushStatusEnabled', false);
                        createEmpCtrl.employerData.settings.isAIJobDescriptionGenerationEnabled = _.get(createEmpCtrl, 'employerData.settings.isAIJobDescriptionGenerationEnabled', false);
                        createEmpCtrl.employerData.settings.videoUrl = _.get(createEmpCtrl, 'employerData.settings.videoUrl', '');
                        createEmpCtrl.employerData.settings.atsCompanyWebsite = _.get(createEmpCtrl, 'employerData.settings.atsCompanyWebsite', '');
                        createEmpCtrl.employerData.settings.atsCompanyLinkedinId = _.get(createEmpCtrl, 'employerData.settings.atsCompanyLinkedinId', '');

                        const logoUrl = _.get(createEmpCtrl, 'employerData.logoURL', '');
                        createEmpCtrl.isImage(logoUrl);
                        createEmpCtrl.transformDataForView(createEmpCtrl.employerData);
                        createEmpCtrl.onChangeCompanies();
                        return response.result;
                    })
                    .then((employer) => {
                        if (employer.resellerEmployerId) {
                            return EmployerService.getReseller(employer._id)
                                .then((response) => response?.result);
                        }
                    })
                    .then((response) => {
                        createEmpCtrl.resellerEmployer = response;
                    })
                    .catch((error) => Logger.error(error));

                EmployerService.getSpecialtiesUpdateStatus($stateParams.empId)
                    .then((response) => {
                        createEmpCtrl.isSpecialtiesUpdated = _.get(response, 'result.isSpecialtiesUpdated');
                    })
                    .catch((error) => Logger.error(error));

                EmployerRepService.getEmployersRepSearch({ employerId: $stateParams.empId })
                    .then((response) => {
                        const employerRepList = _.get(response, 'result');
                        const employerRepOptions = _.chain(employerRepList)
                            .reduce((accumulator, {
                                _id, name, status,
                            }) => {
                                const hasExpectedStatus = _.includes(['active', 'pending'], status.current);
                                const isValidEmployerRep = name && hasExpectedStatus;

                                if (!isValidEmployerRep) {
                                    return accumulator;
                                }
                                return [
                                    ...accumulator,
                                    {
                                        value: _id, label: name, sorting: name.toLowerCase(),
                                    },
                                ];
                            }, [])
                            .sortBy(['sorting'])
                            .value();
                        createEmpCtrl.employerRepOptions = [
                            ...employerRepOptions,
                            { isDivider: 'true' },
                            { value: null, label: 'Unassigned' },
                        ];
                    })
                    .catch((error) => Logger.error(error));
            }
        };

        createEmpCtrl.isImage = function (src) {
            if (!src) {
                createEmpCtrl.imageFailed = true;
                return;
            }
            // eslint-disable-next-line no-undef
            const image = new Image();
            image.src = src;

            image.onerror = function () {
                $timeout(() => {
                    createEmpCtrl.imageFailed = true;
                });
            };
            image.onload = function () {
                $timeout(() => {
                    createEmpCtrl.imageFailed = false;
                });
            };
        };

        createEmpCtrl.addPhone = function () {
            createEmpCtrl.employerData.contact.phone.push({
                type: 'Mobile',
                value: '',
            });
        };

        createEmpCtrl.addLocation = function () {
            createEmpCtrl.employerData.locations.push({
                locationName: '',
                streetAddress: '',
                zipCode: '',
                city: '',
                region: '',
                state: '',
                country: '',
                latitude: '',
                longitude: '',
            });
        };

        createEmpCtrl.addEmail = function () {
            createEmpCtrl.employerData.contact.email.push({
                type: 'Work',
                value: '',
            });
        };

        createEmpCtrl.addWebsite = function () {
            createEmpCtrl.employerData.contact.webAddress.push({
                type: 'Company',
                value: '',
            });
        };

        createEmpCtrl.removeEmail = function (index) {
            createEmpCtrl.employerData.contact.email.splice(index, 1);
        };

        createEmpCtrl.removeLocation = function (idx) {
            createEmpCtrl.employerData.locations.splice(idx, 1);
        };

        createEmpCtrl.removePhone = function (idx) {
            createEmpCtrl.employerData.contact.phone.splice(idx, 1);
        };

        createEmpCtrl.removeWebsite = function (index) {
            createEmpCtrl.employerData.contact.webAddress.splice(index, 1);
        };

        createEmpCtrl.cancel = function () {
            if (createEmpCtrl.isResellerAssociatedEmployer && createEmpCtrl.isNew) {
                this.WebAppRouteService.goPositionsPage({
                    employerId: $stateParams.employerId,
                });
            } else if (createEmpCtrl.outSideUser) {
                $window.history.back();
                $window.history.back();
            } else if (createEmpCtrl.isNew) {
                $state.go('talenya.jobs');
            } else {
                this.WebAppRouteService.goPositionsPage({
                    employerId: createEmpCtrl.employerData._id,
                });
            }
        };

        createEmpCtrl.cleanUpDataToSave = function (employerData) {
            for (const path of ['companies', 'specialties', 'settings.atsAutoUploadFilter']) {
                const value = _.chain(employerData)
                    .get(path)
                    .get('selected')
                    .map('value')
                    .value();

                _.set(employerData, path, value);
            }
        };

        createEmpCtrl.transformDataForView = function (employerData) {
            for (const path of ['companies', 'specialties', 'settings.atsAutoUploadFilter']) {
                const selected = _.chain(employerData)
                    .get(path)
                    .map((value) => ({
                        value,
                        text: value,
                    }))
                    .value();

                _.set(employerData, path, {
                    ...createEmpCtrl.initialData[path],
                    selected,
                });
            }
        };

        createEmpCtrl.generateSpecialties = async function () {
            createEmpCtrl.isSpecialtiesLoading = true;

            const selectedCompanies = _.chain(createEmpCtrl.employerData)
                .get('companies.selected', [])
                .map('value')
                .value();
            try {
                const { result: companies } = await this.companyService.searchCompanyByNames(selectedCompanies);
                createEmpCtrl.employerData.companiesInfoLastUpdate = companies.map(({ CompanyName, LastUpdateDate }) => ({
                    companyName: CompanyName,
                    lastUpdated: LastUpdateDate,
                }));
                const newSpecialties = _.chain(companies)
                    .map('Specialties')
                    .flatten()
                    .map((item) => ({
                        value: item,
                        text: item,
                    }))
                    .value();

                const lowerCasedSelectedSpecialties = createEmpCtrl.employerData.specialties.selected.map((item) => (item.value.toLowerCase()));

                for (const newSpecialty of newSpecialties) {
                    const newSpecialtyLowerCased = _.get(newSpecialty, 'value', '').toLowerCase();
                    if (!lowerCasedSelectedSpecialties.includes(newSpecialtyLowerCased)) {
                        createEmpCtrl.employerData.specialties.selected.push(newSpecialty);
                    }
                }
                createEmpCtrl.isSpecialtiesLoading = false;
                this.$scope.$apply();
            } catch (error) {
                Logger.error(error);
                NotificationService.error('EMPLOYER_DETAILS_FORM_SPECIALTIES_GENERATE_ERROR');
            }
        };

        const _searchForMatchCompanies = async function () {
            const isCompaniesFieldEmpty = _.get(createEmpCtrl.employerData, 'companies.selected.length', 0) === 0;
            const companyNameLength = _.get(createEmpCtrl.employerData, 'name.length', 0);
            if (!isCompaniesFieldEmpty || companyNameLength < MIN_COMPANY_NAME_LENGTH_TO_SEARCH) {
                return;
            }

            createEmpCtrl.isCompaniesLoading = true;

            try {
                const { result: companies } = await this.identifiersService.searchCompanyByFirstNameParts([
                    createEmpCtrl.employerData.name,
                ]);
                const suggestionCompanies = _.chain(companies)
                    .map('printName')
                    .flatten()
                    .map((item) => ({
                        value: item,
                        text: item,
                    }))
                    .slice(0, MAX_SUGGEST_COMPANIES)
                    .value();
                for (const suggestionCompany of suggestionCompanies) {
                    if (!_.some(createEmpCtrl.employerData.companies.selected, suggestionCompany)) {
                        createEmpCtrl.employerData.companies.selected.push(suggestionCompany);
                    }
                }
            } catch (error) {
                Logger.error(error);
                NotificationService.error('EMPLOYER_DETAILS_FORM_COMPANIES_GENERATE_ERROR');
            }
            createEmpCtrl.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
            createEmpCtrl.isCompaniesLoading = false;
            this.$scope.$apply();
        };

        createEmpCtrl.searchForMatchCompanies = _.debounce(_searchForMatchCompanies, 1000);

        createEmpCtrl.onChangeCompanies = function () {
            createEmpCtrl.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
        };

        createEmpCtrl.onChangeAtsAutoUploadFilter = function (value) {
        };

        createEmpCtrl.onBeforeSpecialtyAdded = function ({ value }) {
            _.remove(createEmpCtrl.employerData.specialties.selected, (item) => item.value.toLowerCase() === value.toLowerCase());
        };

        createEmpCtrl.checkIfFieldValid = function (form, inputName) {
            const errors = _.concat(form.$error?.pattern, form.$error?.required);
            return !_.find(errors, { $name: inputName });
        };

        createEmpCtrl.submit = async function (form) {
            createEmpCtrl.isDataSaving = true;
            try {
                if (form.$invalid) {
                    angular.forEach(form.$error, (field) => {
                        angular.forEach(field, (errorField) => {
                            errorField.$setTouched();
                        });
                    });
                    return;
                }

                if (createEmpCtrl?.employerData?.settings?.isGDPR === true) {
                    await this.notificationService.success('EMPLOYER_ACCOUNT_DETAILS_GDPR_NOTIFICATION', true);
                }

                createEmpCtrl.cleanUpDataToSave(createEmpCtrl.employerData);

                const {
                    isDiversityEnabled,
                } = createEmpCtrl.employerData;
                const {
                    isDiversityReportEnabled,
                    isDiversityTagEnabled,
                    isContactForEmployerEnabled,
                    areLinkedinConnectionsEnabled,
                    areLinkedinInMailConnectionsEnabled,
                    isCampaignsAnalysisPageEnabled,
                    isPositionRecommendationsEnabled,
                    shortUrl,
                    isEngagementEnabled,
                } = createEmpCtrl.employerData.settings;
                const dataToUpdate = {
                    ...createEmpCtrl.employerData,
                    settings: {
                        ...createEmpCtrl.employerData.settings,
                        isEngagementEnabled,
                        areLinkedinConnectionsEnabled,
                        areLinkedinInMailConnectionsEnabled,
                        isCampaignsAnalysisPageEnabled,
                        isDiversityReportEnabled: isDiversityEnabled ? isDiversityReportEnabled : false,
                        isDiversityTagEnabled,
                        isContactForEmployerEnabled,
                        isPositionRecommendationsEnabled,
                        shortUrl,
                    },
                };

                if (createEmpCtrl.isNew) {
                    await EmployerService.postEmployer(dataToUpdate)
                        .then((response) => {
                            if (response?.result?.status === 'error') {
                                this.notificationService.error(response?.result?.data?.translationId || 'Employer create error');
                            } else {
                                if (createEmpCtrl.outSideUser) {
                                    $state.go('register');
                                    return;
                                }
                                this.WebAppRouteService.goPositionsPage({
                                    employerId: response.result._id,
                                });
                            }
                        })
                        .catch((error) => {
                            this.notificationService.error('Employer create error');
                            Logger.error(error);
                        });
                } else {
                    await EmployerService.putEmployer($stateParams.empId, dataToUpdate)
                        .then(() => {
                            this.WebAppRouteService.goPositionsPage({
                                employerId: $stateParams.empId,
                            });
                        })
                        .catch((error) => Logger.error(error));
                }
            } finally {
                createEmpCtrl.isDataSaving = false;
            }
        };

        createEmpCtrl.onOfficeChange = ({ value }) => {
            createEmpCtrl.employerData.office = value;
        };

        createEmpCtrl.onCompaniesExcludeOptionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.defaultCompaniesExcludeOption = value;
        };

        createEmpCtrl.onEmployerPostScrapingEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isEmployerPostScrapingEnabled = value;
        };

        createEmpCtrl.onAtsAutoUploadFilterEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAtsAutoUploadFilterEnabled = value;
        };

        createEmpCtrl.onDefaultAccountManagerRecruiterChange = ({ value }) => {
            createEmpCtrl.employerData.defaultAccountManagerRecruiter = value;
        };

        createEmpCtrl.onDefaultAssociatedRecruiterChange = ({ value }) => {
            createEmpCtrl.employerData.defaultAssociatedRecruiter = value;
        };

        createEmpCtrl.onDefaultEmployerRepChange = ({ value }) => {
            createEmpCtrl.employerData.defaultEmployerRep = value;
        };

        createEmpCtrl.onDiversityChange = ({ value }) => {
            createEmpCtrl.employerData.isDiversityEnabled = value;
        };

        createEmpCtrl.onDepartmentsEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isDepartmentsEnabled = value;
        };

        createEmpCtrl.onCampaignEngagement = ({ value }) => {
            createEmpCtrl.employerData.settings.isEngagementEnabled = value;
        };

        createEmpCtrl.onLinkedinConnections = ({ value }) => {
            createEmpCtrl.employerData.settings.areLinkedinConnectionsEnabled = value;
        };

        createEmpCtrl.onLinkedinInMailConnections = ({ value }) => {
            createEmpCtrl.employerData.settings.areLinkedinInMailConnectionsEnabled = value;
        };

        createEmpCtrl.onCampaignsAnalysisPage = ({ value }) => {
            createEmpCtrl.employerData.settings.isCampaignsAnalysisPageEnabled = value;
        };
        createEmpCtrl.onswitchOnAutoCampaignOnCompleteCalibrationChangeChange = ({ value }) => {
            createEmpCtrl.employerData.settings.switchOnAutoCampaignOnCompleteCalibration = value;
        };

        createEmpCtrl.onAutoCampaignTypeSelect = ({ value }) => {
            if (value === this.AutoCampaignTypes.HYBRID) {
                createEmpCtrl.employerData.settings.autoCampaignOptions.selectedDiversityTarget = [];
                createEmpCtrl.employerData.settings.autoCampaignOptions.autoCampaignType = value;
            } else if (_.isEmpty(createEmpCtrl.employerData.settings.autoCampaignOptions.selectedDiversityTarget)) {
                createEmpCtrl.employerData.settings.autoCampaignOptions.autoCampaignType = this.AutoCampaignTypes.REGULAR;
            } else {
                createEmpCtrl.employerData.settings.autoCampaignOptions.autoCampaignType = this.AutoCampaignTypes.DIVERSITY;
            }
        };

        createEmpCtrl.getAutoCampaignValue = (type) => (type === this.AutoCampaignTypes.REGULAR ? this.AutoCampaignTypes.DIVERSITY : type);

        createEmpCtrl.onAutoContactAutoSelectChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAutoContactAutoSelectEnabled = value;
        };

        createEmpCtrl.onAutoQualifyChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAutoQualifyEnabled = value;
        };

        createEmpCtrl.onAtsJobsAutoPushStatusChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAtsJobsAutoPushStatusEnabled = value;
        };

        createEmpCtrl.onAutoInviteToRateSettingChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAutoInviteToRateEnabled = value;
        };

        createEmpCtrl.onProgrammaticCampaignOptionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.programmaticCampaignType = value;
        };

        createEmpCtrl.onAutoCampaignDiversityOptionCheck = (value, field) => {
            const diversityTarget = _.get(createEmpCtrl, 'employerData.settings.autoCampaignOptions.selectedDiversityTarget', []);
            const updatedDiversityTarget = value ? _.uniq([field, ...diversityTarget]) : _.filter(diversityTarget, (v) => v !== field);
            createEmpCtrl.employerData.settings.autoCampaignOptions.selectedDiversityTarget = updatedDiversityTarget;
            this.onAutoCampaignTypeSelect({ value: createEmpCtrl.employerData.settings.autoCampaignOptions.autoCampaignType });
        };

        createEmpCtrl.onPositionRecommendations = ({ value }) => {
            createEmpCtrl.employerData.settings.isPositionRecommendationsEnabled = value;
        };

        createEmpCtrl.onDiversityReportChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isDiversityReportEnabled = value;
        };

        createEmpCtrl.onDiversityTagChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isDiversityTagEnabled = value;
        };

        createEmpCtrl.openTurnOffAtsJobIdConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsJobIdConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_ID_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_ID_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => res(false),
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        createEmpCtrl.openActiveCampaignsExistDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'OpenActiveCampaignsExistDialog',
                title: 'Please stop all active campaigns first in Campaign tab',
                body: 'Please stop all active campaigns first in Campaign tab',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => res(false),
            });
        });

        createEmpCtrl.onAllowTalenyaDefaultEmployerRepForAtsPositions = ({ value }) => {
            // Since original definition changed settings meaning on ui reverted
            createEmpCtrl.employerData.settings.allowTalenyaDefaultEmployerRepForAtsPositions = !value;
        };

        createEmpCtrl.onAtsJobIdChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && createEmpCtrl.employerData.settings.showAtsJobId;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsJobIdConfirmDialog(value);
                if (isSwitchedOff) {
                    createEmpCtrl.employerData.settings.showAtsJobId = value;
                    RouteService.sendEmployerAtsSettingUpdatesNotification({
                        employerId: createEmpCtrl.employerData._id,
                        settingName: 'showAtsJobId',
                    });
                    return isSwitchedOff;
                }
                return false;
            }
            createEmpCtrl.employerData.settings.showAtsJobId = value;
        };

        createEmpCtrl.openTurnOffAtsJobUrlConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsJobUrlConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_JOB_URL_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_JOB_URL_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => {
                    res(false);
                },
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        createEmpCtrl.onAtsJobUrlChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && createEmpCtrl.employerData.settings.showAtsJobUrl;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsJobUrlConfirmDialog(value);
                if (isSwitchedOff) {
                    createEmpCtrl.employerData.settings.showAtsJobUrl = value;
                    RouteService.sendEmployerAtsSettingUpdatesNotification({
                        employerId: createEmpCtrl.employerData._id,
                        settingName: 'showAtsJobUrl',
                    });
                    return isSwitchedOff;
                }
                return false;
            }
            createEmpCtrl.employerData.settings.showAtsJobUrl = value;
        };

        createEmpCtrl.openTurnOffAtsRecruiterConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsRecruiterConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_RECRUITER_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_RECRUITER_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => {
                    res(false);
                },
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        createEmpCtrl.onAtsRecruiterChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && createEmpCtrl?.employerData?.settings?.showAtsRecruiter;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsRecruiterConfirmDialog(value);
                if (isSwitchedOff) {
                    createEmpCtrl.employerData.settings.showAtsRecruiter = value;
                    return isSwitchedOff;
                }
                return false;
            }
            createEmpCtrl.employerData.settings.showAtsRecruiter = value;
        };

        createEmpCtrl.onContactForEmployerChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isContactForEmployerEnabled = value;
        };

        createEmpCtrl.onProfileHiddenDetailsPreviewChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isProfileHiddenDetailsPreviewEnabled = value;
        };

        createEmpCtrl.onShowManageJobChange = ({ value }) => {
            createEmpCtrl.employerData.settings.showManageJob = value;
        };

        createEmpCtrl.onProfileFeedbackModeEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isProfileFeedbackModeEnabled = value;
        };

        createEmpCtrl.onNewLandingPageEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isNewLandingPageEnabled = value;
        };

        createEmpCtrl.onResellerPartnerOptionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isResellerPartner = value;
        };

        createEmpCtrl.onDemoEmployerOptionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isDemoEmployer = value;
            createEmpCtrl.employerData.settings.isEmailEnabled = !value;
        };

        createEmpCtrl.onShowWizardSamplesPageChange = ({ value }) => {
            createEmpCtrl.employerData.settings.showWizardSamplesPage = value;
        };

        createEmpCtrl.onBulkActionsContactByLinkedInEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isBulkActionsContactByLinkedInEnabled = value;
        };

        createEmpCtrl.onJobWizardFastRatingEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isJobWizardFastRatingEnabled = value;
        };

        createEmpCtrl.onOnlyFastRatingAllowedChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isOnlyFastRatingAllowed = value;
            if (!value) {
                createEmpCtrl.employerData.settings.isManualQualifyEnabled = false;
                createEmpCtrl.employerData.settings.isManualQualifyManualFlowEnabled = false;
                createEmpCtrl.employerData.settings.isManualQualifyManualMessagingEnabled = false;
            }
        };

        createEmpCtrl.onSkipCalibrationForSimilarJobsAllowedChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isSkipCalibrationForSimilarJobsAllowed = value;
        };

        createEmpCtrl.onRecalibrationEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isRecalibrationEnabled = value;
        };

        // the whole controller should be rewritten and we should not have bunch of copy-pasted handlers.
        createEmpCtrl.onManualQualifyEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isManualQualifyEnabled = value;

            if (!value) {
                createEmpCtrl.employerData.settings.isManualQualifyManualFlowEnabled = false;
                createEmpCtrl.employerData.settings.isManualQualifyManualMessagingEnabled = false;
            }
        };

        createEmpCtrl.onAtsJobsImmediateUploadEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAtsJobsImmediateUploadEnabled = value;
        };

        createEmpCtrl.onManualQualifyManualFlowEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isManualQualifyManualFlowEnabled = value;
        };

        createEmpCtrl.onManualQualifyLowTalentPoolEnabled = ({ value }) => {
            createEmpCtrl.employerData.settings.isManualQualifyLowTalentPoolEnabled = value;
        };

        createEmpCtrl.onManualQualifyManualMessagingEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isManualQualifyManualMessagingEnabled = value;
        };

        createEmpCtrl.onGDPRChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isGDPR = value;
        };

        createEmpCtrl.onAIJobDescriptionGenerationEnabledChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isAIJobDescriptionGenerationEnabled = value;
        };

        createEmpCtrl.onChangeIsCandidatePhoneRequired = ({ value }) => {
            let requiredCandidateContacts = [...(createEmpCtrl.employerData.settings.interestedCandidateRequiredContacts || [])];
            requiredCandidateContacts = value
                ? [...requiredCandidateContacts, InterestedCandidateContacts.PHONE]
                : requiredCandidateContacts.filter((f) => f !== InterestedCandidateContacts.PHONE);

            createEmpCtrl.employerData.settings.interestedCandidateRequiredContacts = requiredCandidateContacts;
        };

        createEmpCtrl.cityChanged = function (location, index) {
            if (!location.state && location.country != 'IL') {
                return;
            }
            createEmpCtrl.currentCityIndex = index;
            if (!location.city) {
                createEmpCtrl.cityFocusedOn = 0;
                createEmpCtrl.filteredCity = createEmpCtrl.locations.countries[location.countryId].states[location.state];
                return;
            }
            const ans = [];
            for (let i = 0; i < createEmpCtrl.locations.countries[location.countryId].states[location.state].length; i++) {
                if (createEmpCtrl.locations.countries[location.countryId].states[location.state][i].toLowerCase()
                    .indexOf(location.city.toLowerCase()) >= 0) {
                    ans.push(createEmpCtrl.locations.countries[location.countryId].states[location.state][i]);
                }
            }
            createEmpCtrl.cityFocusedOn = 0;
            location.showDropDownCity = true;
            createEmpCtrl.filteredCity = ans;
        };

        createEmpCtrl.onShortUrlChange = (value) => {
            createEmpCtrl.employerData.settings.shortUrl = value;
        };

        createEmpCtrl.editDefaultAssociatedEmployersSettings = function () {
            $state.go(
                'employer.defaultAssociatedEmployersSettings',
                {
                    empId: $stateParams.empId,
                    resellerEmployerData: createEmpCtrl.employerData,
                },
            );
        };

        createEmpCtrl.onUploadMonitorOptionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isUploadMonitorEnabled = value;
        };

        createEmpCtrl.onCandidateFastApplyChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isCandidateFastApplyEnabled = value;
        };

        createEmpCtrl.onFastCalibrationChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isFastCalibrationEnabled = value;
        };

        createEmpCtrl.onMultipleSelectionChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isMultipleSelectionEnabled = value;
        };

        createEmpCtrl.onCompanyOverviewVisibilityChange = ({ value }) => {
            createEmpCtrl.employerData.settings.isCompanyOverviewVisible = value;
        };

        createEmpCtrl.onVideoUrlChange = (value) => {
            createEmpCtrl.employerData.settings.videoUrl = value;
        };

        createEmpCtrl.$onInit = async () => {
            const [
                { result: offices },
                countriesList,
                { result: recruiterList },
            ] = await Promise.all([
                OfficeService.getOffices(),
                staticDataService.getStaticData('countries'),
                createEmpCtrl.isSuperUser
                    ? RecruiterService.getRecruiters(['_id', 'fullName'])
                    : Promise.resolve([]),
            ]);

            createEmpCtrl.isDoNotReplyEnabled = RouteService.getSystemPreference('isDoNotReplyEnabled');
            createEmpCtrl.isManualQualifyFlowEnabled = RouteService.getSystemPreference('manualQualifyFlowEnabled');
            createEmpCtrl.isManualMessagingEnabledInSystem = RouteService.getSystemPreference('isManualQualifyManualMessagingEnabled');

            const recruiterOptions = _.chain(recruiterList)
                .reduce((accumulator, { _id, fullName }) => {
                    if (!fullName) {
                        return accumulator;
                    }
                    return [
                        ...accumulator,
                        {
                            value: _id, label: fullName, sorting: fullName.toLowerCase(),
                        },
                    ];
                }, [])
                .sortBy(['sorting'])
                .value();

            createEmpCtrl.associatedRecruiterOptions = recruiterOptions;
            createEmpCtrl.accountManagerRecruiterOptions = recruiterOptions;
            createEmpCtrl.countriesList = countriesList;
            createEmpCtrl.officeOptions = (offices || []).map((office) => ({ label: office, value: office }));
        };

        createEmpCtrl.init();
    }

    onLocationChange = function ($item, $index) {
        const {
            locationName,
            city,
            state,
            country,
            latitude,
            longitude,
        } = this.locationService.getLocationObjectFromDbLocationItem({
            locationItem: $item,
            countriesList: this.countriesList,
        });

        if ($item.isGdpr && this.employerData.settings.isGDPR !== true) {
            this.notificationService.success('EMPLOYER_ACCOUNT_DETAILS_GDPR_NOTIFICATION');
            this.onGDPRChange({ value: true });
        }

        this.employerData.locations[$index] = {
            ...this.employerData.locations[$index],
            locationName,
            city,
            state,
            country,
            latitude,
            longitude,
            streetAddress: '',
            zipCode: '',
        };
    };

    getIsGenerateSpecialtiesButtonEnabled() {
        return _.get(this.employerData, 'companies.selected.length', 0) > 0;
    }

    $onChanges() {
        this.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
    }
}

export const CreateNewEmployerConfiguration = {
    template,
    controller: CreateNewEmployer,
    controllerAs: 'createEmpCtrl',
};

angular
    .module('TALENYA-FE')
    .component('createNewEmployer', CreateNewEmployerConfiguration);
